module.exports = __webpack_public_path__ + "img/weinankauf.c0a2b1db.svg";